import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import BadgeType from '../../../shared/enums/badge-type.enums';
import { Sizes } from '../../../shared/enums/shared.enums';
import ViewportType from '../../../shared/enums/viewport-type.enums';

@Component({
  selector: 'hdi-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class BadgeComponent {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() type: BadgeType = BadgeType.DEFAULT;
  @Input() label: string = 'Badge';
  @Input() size: Sizes = Sizes.MEDIUM;

  protected readonly BadgeType = BadgeType;
}
